import asMyList from '../../components/asMyList.js';
import asCatalog from '../../components/asCatalog.js';
import BottlebooksStandardCatalog from './BottlebooksStandardCatalog';
import BottlebooksStandardCatalog2 from './BottlebooksStandardCatalog2';
import ExhibitorQrCodeLabels8164 from './ExhibitorQrCodeLabels8164';
import ExhibitorQrCodeLabelsL7169 from './ExhibitorQrCodeLabelsL7169';
import TastingBooklet from './TastingBooklet';

// This follows the naming conventions from Classic
export const templates = {
  'brn:print:bottlebooks:me.bottlebooks.standard2020': asMyList(
    BottlebooksStandardCatalog
  ),
  'brn:print:bottlebooks:me.bottlebooks.standard2020-3mm': asMyList(
    BottlebooksStandardCatalog
  ),
  'brn:print:bottlebooks:me.bottlebooks.standard2020-5mm': asMyList(
    BottlebooksStandardCatalog
  ),
  'brn:print:bottlebooks:me.bottlebooks.standardCatalog2': asMyList(
    BottlebooksStandardCatalog2
  ),
  'brn:print:bottlebooks:me.bottlebooks.exhbitorQRCodeLabels8164': asCatalog(
    ExhibitorQrCodeLabels8164
  ),
  'brn:print:bottlebooks:me.bottlebooks.exhbitorQRCodeLabelsL7169': asCatalog(
    ExhibitorQrCodeLabelsL7169
  ),
  'Bottlebooks/TastingBooklet': asMyList(TastingBooklet),
};
